// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1esYY","rootSuccess":"CompleteLink_rootSuccess__vO68h","rootFailure":"CompleteLink_rootFailure__2H7DD","isDisabled":"CompleteLink_isDisabled__1cDy1"};